import React from 'react'

import PropTypes from 'prop-types'

import TextLink from '../../../TextLink'

const COOKIE_CONSENT_URL = 'https://termly.io/products/cookie-consent-manager/?utm_source=cookie-banner&utm_medium=banner&utm_campaign=cookie-consent-banner'


export default function CookieConsentLink({ children }) {
  return (
    <TextLink
      href={ COOKIE_CONSENT_URL }
      rel="noreferrer"
      target="_blank"
    >
      { children }
    </TextLink>
  )
}

CookieConsentLink.propTypes = {
  children: PropTypes.node.isRequired,
}
